<h3 mat-dialog-title>{{data.id ?
  'Modifier':
'Créer'}} un rôle</h3>
<mat-dialog-content class="caaks-dialog-text">
  <div>Renseigner les informations suivantes.</div>
  <div>
    <form [formGroup]="roleForm" novalidate>
      <div>

        <mat-form-field>
          <input matInput formControlName="name" placeholder="Nom du rôle" required />
          @if (name!.hasError('invalid')) {
            <mat-error>
              L'name est mal formaté.
            </mat-error>
          }
          @if (name!.hasError('uniqueName')) {
            <mat-error>
              Un compte existe déjà avec cet name.
            </mat-error>
          }
          @if (name!.hasError('required')) {
            <mat-error> L'name est requis. </mat-error>
          }
        </mat-form-field>

        <!--
        <mat-form-field>

          <mat-chip-list #chipList>
            <mat-chip *ngFor="let option of selectedOptions" [removable]="true" (removed)="removeOption(option)">
              {{ option.name }}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
            <input type="text" formControlName="permissions" matInput placeholder="Ajouter une permission"
              [matAutocomplete]="autoP" [matChipInputFor]="chipList"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes">
          </mat-chip-list>
          <mat-autocomplete #autoP="matAutocomplete">
            <mat-option *ngFor="let option of  filteredPermissionsByName|async" [value]="option"
              (optionSelected)="addOption($event,option)">
              <mat-checkbox [checked]="option.selected" (change)="addOption($event,option)"
                (click)="$event.stopPropagation()">
                {{ option.name }}
              </mat-checkbox>
            </mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="permissions!.hasError('uniqueName')">
            Une ressource existe déjà avec ce nom.
          </mat-error>
          <mat-error *ngIf="permissions!.hasError('required')"> Le nom est requis. </mat-error>
        </mat-form-field>
        -->
        <app-autocomplete formControlName="permissions" [optionsDictionnary]="permissionsListDictionary"
          [placeholder]="'Ajouter une permission'" (optionSelected)="selectedOption($event)"
        (optionRemoved)="removeOption($event)" [displayProperty]="'name'" [valueProperty]="'name'"></app-autocomplete>

      </div>
    </form>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <ng-container>
    <button mat-button type="submit" color="primary" [disabled]="isCreateDisabled()" (click)="add()">{{data.id ?
      'Modifier':
    'Créer'}}</button>
    <button mat-button (click)="cancel()">Annuler</button>
  </ng-container>
</mat-dialog-actions>